
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.554 13.381c-.047 0-.047 0-.047-.047l-.14-.796-2.155-.047c-.047 0-.047 0-.047-.047-.047-.421-.094-.937-.047-1.03.047-.094.094-.094.14-.094l2.015-.047.047-.047c-.047-.281-.469-2.858-.469-4.03-.937 0-6.325-.046-6.325-.046-.047 0-.047 0-.047-.047l-.234-.75c0-.093-.094-.421 0-.562.094-.14.234-.234.469-.234h4.498V4.76c0-.093 0-.14.046-.187h-.515c-.047 0-.187 0-.187-.094s.046-.14.562-.14h.14c.047-.188.14-.281.188-.281.093 0 .14.093.187.28h.094c.562 0 .609.048.609.141 0 .094-.047.14-.61.14H5.68c0 .048.047.095.047.188v.797h1.03v-1.5s0-.515.141-1.077.328-1.171.328-1.171c0-.047.094-.235.281-.235.188 0 .281.14.281.235 0 0 .188.609.328 1.17.14.563.14 1.078.14 1.078v1.5l.048.047h.984v-.797c0-.047 0-.14.047-.187h-.422c-.14 0-.234-.047-.234-.14 0-.095.046-.141.609-.141h.093c.047-.188.14-.282.188-.282.093 0 .14.094.187.282h.14c.516 0 .563.046.563.14 0 .094-.094.14-.469.14h-.234c0 .048.047.141.047.188v.797h4.498c.187 0 .375.093.468.234.094.14 0 .468 0 .515l-.234.75c0 .047-.047.047-.047.047s-5.388.047-6.325.047c0 1.124-.421 3.7-.468 4.029l.047.047 2.014.047c.047 0 .094 0 .14.093.048.094 0 .61-.046 1.031 0 .047-.047.047-.047.047l-2.155.047-.14.796c.093-.047.093 0 .046 0z"}})])
          )
        }
      }
    